module.exports = __webpack_public_path__ + "static/img/body-bg1.00c9dbdd.png";